import { styled } from 'styled-components';
import { flexMixin, textMixin } from '@styles/mixins';
import { colors } from '@styles';

export const StyledLink = styled.a`
    cursor: pointer;
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    color: #1677ff;
`;

export const TextWrapper = styled.div`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 500,
    })};
`;
export const StyledAcceptedLabel = styled.div`
    ${flexMixin('column', 'center', 'center')};
    box-sizing: border-box;
    width: 133px;
    height: 38px;
    border: 1px solid rgba(143, 143, 143, 0.3);
    border-radius: 5px;

    & span {
        ${textMixin({
            fontSize: '14px',
            fontWeight: 500,
        })};
        line-height: 28px;
        color: green;
    }
`;
export const StyledCompletedLabel = styled.div`
    ${flexMixin('column', 'center', 'center')};
    box-sizing: border-box;
    width: 133px;
    height: 38px;
    border: 1px solid rgba(143, 143, 143, 0.3);
    border-radius: 5px;

    & span {
        ${textMixin({
            fontSize: '14px',
            fontWeight: 500,
        })};
        line-height: 28px;
        color: blue;
    }
`;

export const StyledNotAcceptedLabel = styled.div`
    ${flexMixin('column', 'center', 'center')};
    box-sizing: border-box;
    width: 133px;
    height: 38px;
    border: 1px solid rgba(143, 143, 143, 0.3);
    border-radius: 5px;

    & span {
        ${textMixin({
            fontSize: '14px',
            fontWeight: 500,
        })};
        line-height: 28px;
        color: #dd1a6a;
    }
`;
export const StyledRoseSpan = styled.span`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    line-height: 120%;
    color: ${colors.primaryBg};
`;
export const Sspan = styled.span`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 700,
    })};
    line-height: 28px;
    text-align: right;
    color: ${colors.grey};
`;

export const Nspan = styled.span`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    line-height: 28px;
    text-align: right;
    color: #8f8f8f;
`;
